/* eslint-disable import/prefer-default-export, no-return-await */
import { api } from "jiffy-api";
import { EventBus, Events } from "jiffy-store";
import { redirectTo } from "common/utils/browser";
import { isSessionExpired, withCsrfRetry } from "common/utils/csrf-token-manager";
import EventClass from "common/utils/ui/event-class";
import { incrementHeaderCounter } from "../masthead-cart/masthead-cart";

export class BuyItAgainDtfBuy extends EventClass {
  #variantId = null;

  #dtfPrintId = null;

  #productId = null;

  #getQty;

  constructor(props) {
    super(props);

    this.#getQty = props.getQty;
  }

  async #submit() {
    const payload = {
      variant_id: this.#variantId,
      quantity: this.#getQty?.() || 1,
      dtf_print_ids: [this.#dtfPrintId],
      source_page: "orders_history"
    };

    return await api.dtf.addToCartPrint(payload);
  }

  set variantId(variantId) {
    this.#variantId = variantId;
  }

  set dtfPrintId(dtfPrintId) {
    this.#dtfPrintId = dtfPrintId;
  }

  set productId(productId) {
    this.#productId = productId;
  }

  #buildDtfData({ quantity, width, height, price }) {
    return [
      {
        id: this.#dtfPrintId,
        catalogNumber: "Jiffy Transfers",
        brandName: "",
        productId: this.#productId,
        variantId: this.#variantId,
        color: "",
        image: "",
        quantity,
        size: `${width}" x ${height}"`,
        price: `$${Number(price).toFixed(2)}`,
        preCut: false,
        preCutPrice: 0
      }
    ];
  }

  async event(event, $target) {
    try {
      $target.setAttribute("disabled", "disabled");
      const response = await withCsrfRetry(() => this.#submit(), "buy_it_again_dtf");
      const artworkPrice = response.artwork_prices[this.#dtfPrintId];
      incrementHeaderCounter(artworkPrice.quantity);
      super.event(event, $target);
      EventBus.publish(Events.MOBILE_GRID_SUBMIT, {
        dtfData: this.#buildDtfData(artworkPrice),
        bannerHtml: response.banner_html
      });
      EventBus.publish(Events.ITEMS_ADDED_TO_CART, { ...response, is_dtf: true });
    } catch (error) {
      if (isSessionExpired(error)) {
        redirectTo("/login");
        return;
      }
      window.Honeybadger?.notify("Error adding to cart", {
        params: { error: JSON.stringify(error) }
      });
    } finally {
      $target.removeAttribute("disabled");
    }
  }
}
